import { cloneDeep } from 'lodash'
import { getNextEntityId } from '../getNextEntityId'
import { getRecursPaidDescr } from './RecursPaid'
import type { TMSServiceWithOmits } from '~/types/msService/models'
import type { IProductKitItem } from '~/types/product/models'

export function buildServiceForKitItem({
  rootEntity,
  kitService,
  item,
}: {
  rootEntity: string
  kitService: TMSServiceWithOmits
  item: IProductKitItem
}): TMSServiceWithOmits {
  const newId = getNextEntityId({
    entityName: `${rootEntity}MSService`,
  })

  return {
    id: newId,
    masterService: kitService.masterService,
    type: kitService.type,
    product: cloneDeep(item.product),
    parentProduct: kitService.product.doExcludeKitServiceWhenBuildingServices
      ? kitService.parentProduct
      : {
          id: kitService.product.id,
          label: kitService.product.descr,
        },
    parentMSServiceId: kitService.product
      .doExcludeKitServiceWhenBuildingServices
      ? kitService.parentMSServiceId
      : kitService.id,
    descr: item.product.descr, // default. Will be replaced by supplierProductItem descr if there is one.
    origin: kitService.origin,
    location: kitService.location,
    supplier: kitService.supplier,
    tsd: kitService.tsd,
    splitFraction: kitService.splitFraction ?? 0,
    term: kitService.term,
    recurs: kitService.recurs,
    paid: kitService.paid,
    recursPaidDescr: getRecursPaidDescr({
      recurs: kitService.recurs,
      paid: kitService.paid,
    }),
    kitQuantity:
      kitService.product.doExcludeKitServiceWhenBuildingServices &&
      kitService.parentMSServiceId === undefined
        ? kitService.quantity
        : item.quantity,
    quantity: 0,
    unitRcAmount: 0,
    mrcAmount: 0,
    unitNrcAmount: 0,
    nrcAmount: 0,
    oneTimeAmount: 0,
    tcvAmount: 0,
    doMultiplyNrcByQuantity: false,
    closeByDate: kitService.closeByDate,
    quoteDate: kitService.quoteDate,
    status: kitService.status,
    doInclude: kitService.doInclude,
    canBeDeleted: true,
  }
}
